import { useContext } from "react"
import { Button } from "@headlessui/react"
import { MultiContext } from "~/contexts/MultiContext"

export function MiniLayout({
  Icon,
  onClick = () => {},
  enabledOptions = "active",
  disabledPositions = [],
}) {
  const { layout, positions } = useContext(MultiContext)

  const gridClasses =
    layout === 4
      ? "grid-cols-2 grid-rows-2"
      : layout === 9
      ? "grid-cols-3 grid-rows-3"
      : layout === 3
      ? "grid-cols-3 grid-rows-2"
      : layout === 6
      ? "grid-cols-3 grid-rows-3"
      : layout === 7
      ? "grid-cols-4 grid-rows-4"
      : "grid-cols-1" // layout === 1

  const positionClasses = (layout, position) => {
    if (layout === 3 && position === 1) {
      return "col-span-2 row-span-2"
    } else if (layout === 6 && position === 1) {
      return "col-span-2 row-span-2"
    } else if (layout === 7 && position === 1) {
      return "col-span-2 row-span-2 !p-2"
    } else if (layout === 7 && position === 2) {
      return "col-span-2 row-span-2 !p-2"
    } else if (layout === 7 && position === 3) {
      return "col-span-2 row-span-2 !p-2"
    } else if (layout === 7) {
      return "!p-2"
    } else {
      return ""
    }
  }

  const isEnabled = (uuid, position) => {
    if (enabledOptions === "all") {
      return disabledPositions.includes(position) ? false : true
    }

    if (enabledOptions === "none") {
      return false
    }

    if (enabledOptions === "inactive") {
      return uuid ? false : true
    }

    if (disabledPositions.includes(position)) {
      return false
    }

    return uuid ? true : false
  }

  return (
    <div className={`grid gap-2 text-center sm:h-48 ${gridClasses}`}>
      {Array.from(Array(layout)).map((_, i) => (
        <Button
          className={`grid place-content-center rounded-lg p-4 transition ${positionClasses(
            layout,
            i + 1
          )} ${
            isEnabled(positions[i + 1], i + 1)
              ? "bg-gray-900/10 font-bold text-gray-800 hover:bg-gray-600/10"
              : "bg-gray-600/10 text-gray-400"
          }`}
          key={i}
          disabled={!isEnabled(positions[i + 1], i + 1)}
          onClick={() => onClick({ position: parseInt(i + 1), uuid: positions[i + 1] })}
        >
          <Icon className="h-6 w-6" />
        </Button>
      ))}
    </div>
  )
}
